import { combineReducers } from 'redux';
import { fetchAuth } from './redAuth-LoginReducers';
import { fetchCards } from './redCards-CardsDatatableReducer';
import { fetchComponentList } from './components/redComponents-ComponentList';
import { fetchGroupList } from './units/redUnits-GroupList'
import { fetchSubGroupList } from './units/redUnits-SubGroupList'
import { fetchAdminList } from './satuan/redSatuan-AdminSatuanList';
import { fetchTipeSatuanList } from './satuan/redSatuan-TipeSatuanList'
import { fetchBagianSatuanList } from './satuan/redSatuan-BagianSatuanList'
import { fetchTypeList } from './units/redUnits-TypeList'
import { fetchSubTypeList } from './units/redUnits-SubTypeList';
import { fetchUnitList } from './units/redUnits-UnitList'
import { fetchTaskList } from './tasks/redTask-TaskList'
import { fetchTaskActivity } from './tasks/redTask-ActivityList'
import { fetchGetSatuanPage } from './satuan/redSatuan-GetPageSatuan'
import { fetchMemberList } from './satuan/redSatuan-MemberList'
import { fetchComponentTreeList } from './components/redComponents-ComponentTreeList'
import { fetchUnitComponentList } from './components/redComponents-UnitComponentList'
import { fetchDashboardUnit } from './dashboard/redDashboard-Unit';
import { fetchDashboardAlert } from './dashboard/redDashboard-Alert'
import { fetchCommanderDashboard } from './dashboard/redDashboard-Commander'
import { fetchUserPhoto } from  './satuan/redUsers-UserPhoto';
import { fetchOrganizationList} from './satuan/redSatuan-GetOrganization';
import { fetchUserList} from './users/redUser-GetUserList';
import { fetchRolePermissionList } from './users/redUsers-RolePermissionList'
import { fetchGroupReportList } from './report/redReport-GroupList';
import { fetchReportList } from './report/redReport-ReportList'
import { fetchBudgetYearlyComponent } from './budgeting/redBudgeting-YearlyComponent'
import { fetchBudgetYearlyChildren } from './budgeting/redBudgeting-YearlyChildren'
import { fetchComponentNotChildren } from './components/redComponent-NotChildrenList';
import { fetchReportPage } from './report/redReport-ReportPage'
import { fetchParentDivision } from './satuan/redSatuan-ParentDivision'
import { fetchMenuList } from './users/redUsers-MenuList'

const rootReducers = combineReducers({
    authStore: fetchAuth,
    cardsTableStore: fetchCards,

    dashboardStore: fetchDashboardUnit,
    commanderStore: fetchCommanderDashboard,
    alertStore: fetchDashboardAlert,
    taskStore: fetchTaskList,
    activityStore: fetchTaskActivity,

    //satuan
    userAdminListStore: fetchAdminList,
    tipeSatuanListStore: fetchTipeSatuanList,
    bagianSatuanListStore: fetchBagianSatuanList,
    getSatuanPageDataStore: fetchGetSatuanPage,
    memberStore: fetchMemberList,
    userPhotoStore: fetchUserPhoto,
    organizationStore : fetchOrganizationList,
    parentDivisionStore: fetchParentDivision,

    //Group
    groupStore: fetchGroupList,
    subGroupStore: fetchSubGroupList,

    //Type
    typeStore: fetchTypeList,
    subTypeStore: fetchSubTypeList,

    //Unit
    unitStore: fetchUnitList,

    //Component
    componentTreeStore: fetchComponentTreeList,
    componentStore: fetchComponentList,
    componentNotChildrenStore: fetchComponentNotChildren,
    unitComponentStore: fetchUnitComponentList,

    //User
    userStore:fetchUserList,
    rolePermissionStore: fetchRolePermissionList,
    menuStore: fetchMenuList,

    //Report
    reportStore: fetchReportList,
    groupReportStore: fetchGroupReportList,
    groupReportPageStore: fetchReportPage,

    //Budgeting
    budgetStore: fetchBudgetYearlyComponent,
    divisionBudgetStore: fetchBudgetYearlyChildren,
});

export default rootReducers;



// WEBPACK FOOTER //
// ./src/redux/reducers/index.jsx